import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const sizesMap = {
  h2: 'text-2xl',
  'p-lg': 'text-sm',
};

const Typography = ({ variant, component, text, fontWeight, secondary }) => {
  const classes = clsx(
    sizesMap[variant],
    `font-${fontWeight}`,
    secondary && 'text-grey-500',
    'text-center',
  );

  let componentVariant;
  if (component === undefined) componentVariant = variant.includes('p') ? 'p' : variant;
  else componentVariant = component;
  switch (componentVariant) {
    case 'h1':
      return <h1 className={classes}>{text}</h1>;
    case 'h2':
      return <h2 className={classes}>{text}</h2>;
    case 'h3':
      return <h3 className={classes}>{text}</h3>;
    case 'p':
      return <p className={classes}>{text}</p>;
    default:
      return undefined;
  }
};

Typography.propTypes = {
  variant: PropTypes.oneOf(['h2', 'p-lg']).isRequired,
  text: PropTypes.string.isRequired,
  fontWeight: PropTypes.oneOf(['normal', 'medium', 'bold']),
  secondary: PropTypes.bool,
};

Typography.defaultProps = {
  fontWeight: 'normal',
  secondary: false,
};

export default Typography;
